import React from 'react';

interface PhoneAppShellProps {
  children: React.ReactNode;
}

export const PhoneAppShell: React.FC<PhoneAppShellProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-200 via-slate-100 to-slate-200 font-poppins">
      <div className="mx-auto min-h-screen w-full md:max-w-6xl md:px-6 md:py-8">
        <div className="min-h-screen bg-white md:min-h-[calc(100vh-4rem)] md:overflow-hidden md:rounded-[32px] md:border md:border-enpal-downriver/10 md:shadow-[0_20px_60px_rgba(7,37,67,0.15)]">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PhoneAppShell;
